import React from 'react'
import { BaresHeroSection } from '../components/sections/bares/BaresHeroSection'
import { BaresSuitePillars } from '../components/sections/bares/BaresSuitePillars'
import { BaresOrderingFlow } from '../components/sections/bares/BaresOrderingFlow'
import { BaresKDSSection } from '../components/sections/bares/BaresKDSSection'
import { BaresBillingSection } from '../components/sections/bares/BaresBillingSection'
import { BaresSitePersonalization } from '../components/sections/bares/BaresSitePersonalization'
import { BaresTechArchitecture } from '../components/sections/bares/BaresTechArchitecture'
import { BaresEngagementSection } from '../components/sections/bares/BaresEngagementSection'
import { BaresERPShowcase } from '../components/sections/bares/BaresERPShowcase'
import { BaresFAQSection } from '../components/sections/bares/BaresFAQSection'
import { BaresCTA } from '../components/sections/bares/BaresCTA'

export const BaresSuitePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <BaresHeroSection />
      <BaresSuitePillars />
      <BaresOrderingFlow />
      <BaresKDSSection />
      <BaresBillingSection />
      <BaresSitePersonalization />
      <BaresTechArchitecture />
      <BaresERPShowcase />
      <BaresEngagementSection />
      <BaresFAQSection />
      <BaresCTA />
    </div>
  )
}

export default BaresSuitePage
